import styled from "@emotion/styled";
import { CircularProgress } from "@mui/material";

const Root = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100vh;
`;

function Loader() {
  return (
    <Root>
      <CircularProgress />
    </Root>
  );
}

export default Loader;
